import { createFileRoute } from "@tanstack/react-router";
import { AdminPageHeader } from "@/components/admin/admin-shell";
import { CrudManager } from "@/components/admin/crud-manager";

export const Route = createFileRoute("/_authenticated/admin/bannerler")({
  component: Page,
});

function Page() {
  return (
    <div>
      <AdminPageHeader title="Bannerlər" description="Saytdakı reklam bannerlərini idarə et" />
      <CrudManager
        table="banners"
        addLabel="Yeni banner"
        emptyText="Hələ banner yoxdur."
        fields={[
          { name: "title", label: "Başlıq" },
          { name: "image_url", label: "Şəkil linki" },
          { name: "link_url", label: "Keçid linki" },
          {
            name: "position",
            label: "Yerləşmə",
            type: "select",
            options: [
              { value: "home_top", label: "Ana səhifə — yuxarı" },
              { value: "home_middle", label: "Ana səhifə — orta" },
              { value: "listing_side", label: "Elan səhifəsi — yan" },
              { value: "search_top", label: "Axtarış — yuxarı" },
            ],
          },
          { name: "sort_order", label: "Sıra", type: "number" },
          { name: "active", label: "Aktiv", type: "boolean" },
        ]}
        columns={[
          {
            name: "image_url",
            label: "Şəkil",
            render: (r) =>
              r["image_url"] ? (
                <img src={r["image_url"]} alt="" className="size-10 rounded-lg object-cover" />
              ) : (
                "—"
              ),
          },
          { name: "title", label: "Başlıq" },
          { name: "position", label: "Yerləşmə" },
          { name: "sort_order", label: "Sıra" },
          { name: "active", label: "Vəziyyət", render: (r) => (r["active"] ? "Aktiv" : "Deaktiv") },
        ]}
      />
    </div>
  );
}
